import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ProductEditDefaultTemplate } from 'components/Templates'

const ProductEditDefault: FC = () => {
  return (
    <Layout title={'商品情報のテンプレート設定'}>
      <ProductEditDefaultTemplate />
    </Layout>
  )
}

export default ProductEditDefault
